import axios from "axios";

const checkAll = document.querySelector('[data-check-all]');
if (checkAll) {
    checkAll.addEventListener('change', (e) => {
        document.querySelectorAll('[data-checkbox]').forEach((item) => {
            item.checked = checkAll.checked
        })
    })
}